function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { RcGroup } from '../../hooks/group';
import { classnames } from '@bydesign-ui/utils';
import { useCombineCallback } from '@bydesign-ui/hooks';
import React, { useCallback } from 'react';
import { usePrefixCls } from '@byte-design/config';
import { Button } from '../button';
import { RadioGroupButton } from './Button';
import { RadioGroupRadio } from './Radio';
import { RadioGroupTag } from './Tag';
import { RadioGroupFilled } from './Filled';
export function RadioGroup(props) {
  var _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      _props$type = props.type,
      type = _props$type === void 0 ? 'radio' : _props$type,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      value = props.value,
      onChange = props.onChange,
      onValueChange = props.onValueChange,
      children = props.children,
      className = props.className,
      minWidth = props.minWidth,
      extra = _objectWithoutProperties(props, ["size", "type", "disabled", "value", "onChange", "onValueChange", "children", "className", "minWidth"]);

  var handleChange = useCombineCallback(onChange, onValueChange);
  var onGroupChange = useCallback(function (nv) {
    handleChange(nv.length === 0 ? undefined : nv[0]);
  }, []);
  var cls = classnames(usePrefixCls('radio-group', {
    type: type,
    size: size,
    disabled: disabled
  }), className);
  return React.createElement(RcGroup, Object.assign({}, extra, {
    className: cls,
    disabled: disabled,
    extraProps: {
      size: size,
      type: type
    },
    value: value == null ? [] : [value],
    onChange: onGroupChange,
    minWidth: minWidth
  }), type === 'button' ? React.createElement(Button.Group, null, children) : children);
}
RadioGroup.Radio = RadioGroupRadio;
RadioGroup.Button = RadioGroupButton;
RadioGroup.Tag = RadioGroupTag;
RadioGroup.Filled = RadioGroupFilled;